export const convertEmptyKeyToNull = object => {
    Object.keys(object).forEach(key => {
        object[key] = object[key] || null;
    });

    return object;
};

export default convertEmptyKeyToNull;
